<template>
    <div id="ns-bar-chart" ref="chart" style="width: 100%; height: 400px;"></div>
  </template>
  
  <script>
  import echarts from 'echarts';
  
  export default {
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        chartData: {
          labels: this.data.labels,
          first_audit_data: this.data.first_audit_data,
          second_audit_data: this.data.second_audit_data,
          third_audit_data: this.data.third_audit_data,
        },
      };
    },
    mounted() {
      this.renderChart();
    },
    methods: {
      renderChart() {
        const chart = echarts.init(this.$refs.chart);
  
        const emphasizeStyle = {
          color: 'rgba(0, 0, 255, 0.7)', // Color for emphasized bars
        };
  
        const seriesData = [
          {
            name: '1st Audit',
            type: 'bar',
            data: this.chartData.first_audit_data.map((item, index) => ({
              value: item,
              emphasis: emphasizeStyle,
            })),
            animation: false, // Disable animation
            label: {
              show: true,
              position: 'top',
            },
            itemStyle: {
              color: '#2E8B57', // Custom color for the 1st Audit
            },
          },
          {
            name: '2nd Audit',
            type: 'bar',
            data: this.chartData.second_audit_data.map((item, index) => ({
              value: item,
              emphasis: emphasizeStyle,
            })),
            animation: false,
            label: {
              show: true,
              position: 'top',
            },
            itemStyle: {
              color: '#CD5C5C', // Custom color for the 1st Audit
            },
          },
          {
            name: '3rd Audit',
            type: 'bar',
            data: this.chartData.third_audit_data.map((item, index) => ({
              value: item,
              emphasis: emphasizeStyle,
            })),
            animation: false,
            label: {
              show: true,
              position: 'top',
            },
            itemStyle: {
              color: '#E9A098', // Custom color for the 1st Audit
            },
          },
        ];
  
        chart.setOption({
          xAxis: {
            type: 'category',
            data: this.chartData.labels,
            axisLabel: {
              interval: 0, // Force all labels to be displayed
            //   rotate: -45, // You can adjust the rotation angle as needed
            },
          },
          yAxis: [
            {
              type: 'value',
              name: '1st Audit',
            },
            {
              type: 'value',
              name: '2nd Audit',
            },
            {
              type: 'value',
              name: '3rd Audit',
            },
          ],
          series: seriesData,
          legend: {
            data: ['1st Audit', '2nd Audit', '3rd Audit'],
          },
        });
      },
    },
  };
  </script>
  